// src/Activities.js

import React from 'react';
import './Activities.css';

const Activities = () => {
  return (
    <section className="activities">
      <h2>What you'll get up to</h2>
      <ul>
        <li><span>🤸</span> Open jump in the arena</li>
        <li><span>🎈</span> Giant inflatable slides</li>
        <li><span>🏰</span> Bounce houses &amp; obstacle courses</li>
        <li><span>🍕</span> Pizza in the party room</li>
        <li><span>🍰</span> Cake &amp; treats</li>
      </ul>
    </section>
  );
};

export default Activities;
